export default function (order: ServerOrderI): OrderI {
  const additional = {};
  // console.log(order?.expand);
  if (order?.expand?.user) {
    additional.contactInfo = order?.expand?.user?.contactInfo;
    additional.points = order?.expand?.user?.cash;
    additional.userName = order?.expand?.user?.name;
  }

  return {
    id: order.id,
    localId: order.localId,
    item: getItemByTypeAndName(order.itemType, order.itemName),
    stickers: order.customizer.stickers,
    lines: order.customizer.lines,
    pencils: order.customizer.pencils,
    customizerComment: order.customizer.comment,
    file: order.file,
    files: order.files,
    approveFile: order.approveFile,
    approveComments: order.approveComments,
    comment: order.comment,
    patient: order.patient,
    created: order.created,
    status: order.status,
    approved: order.approved,
    totalPrice: order.totalPrice,
    userName: '',
    user: order.user,
    deliveryDetails: order.deliveryDetails,
    billingDetails: order.billingDetails,
    paid: order.paid,
    discount: order.discount,
    configuration: order.configuration,
    ...additional,
    // contactInfo: order.contactInfo,
  };
}
